export enum AnimatedIconVariant {
  AlarmSensor = 'alarm-sensor',
  AnnualReport = 'annual-report',
  BuildingAnalysis = 'building-analysis',
  Calculator = 'calculator',
  Calendar = 'calendar',
  ChargingStation = 'charging-station',
  ChargingStationInverse = 'charging-station-inverse',
  City = 'city',
  Coin = 'coin',
  Coin50 = 'coin-50',
  Company = 'company',
  ContactPerson = 'contact-person',
  ContractAmendents = 'contract-amendents',
  Contracting = 'contracting',
  Coupon = 'coupon',
  DangerElectricity = 'danger-electricity',
  Diamond = 'diamond',
  Efficiency = 'efficiency',
  EInvoice = 'e-invoice',
  ElectricMeter = 'electric-meter',
  EnercityE = 'enercity-e',
  EnergyConsulting = 'energy-consulting',
  EnergyGasCircle = 'energy-gas-circle',
  Faq = 'faq',
  Fire = 'fire',
  GlassFiber = 'glass-fiber',
  GlassFiberSurrogate = 'glass-fiber-surrogate',
  Handshake = 'handshake',
  Heat = 'heat',
  Home = 'home',
  HomeShield = 'home-shield',
  HouseConnection = 'house-connection',
  IBAN = 'iban',
  Infothek = 'infothek',
  Keys = 'keys',
  LightBulb = 'light-bulb',
  Lightning = 'lightning',
  Lock = 'lock',
  Map = 'map',
  MovingTruck = 'moving-truck',
  None = 'none',
  OilHeating = 'oil-heating',
  Person = 'person',
  Phone = 'phone',
  Plug = 'plug',
  PowerGas = 'power-gas',
  Press = 'press',
  Profit = 'profit',
  RFID = 'rfid',
  Rocket = 'rocket',
  Search = 'search',
  Smarthome = 'smarthome',
  Solar = 'solar',
  SolarPanel = 'solar-panel',
  StreetLight = 'street-light',
  SurFon = 'surf-fon',
  Together = 'together',
  Tools = 'tools',
  Training = 'training',
  TreeTrunk = 'tree-trunk',
  WaterDrop = 'water-drop',
  Wind = 'wind',
  WindPower = 'wind-power',
  Worldwide = 'worldwide',
  // small variants

  ColdWaterSmall = 'cold-water-small',
  WarmWaterSmall = 'warm-water-small',
  EnergyFireSmall = 'energy-fire-small',
  HeatSmall = 'heat-small',
  LightningSmall = 'lightning-small',
  StreetLightSmall = 'street-light-small',
}
